export default __webpack_public_path__ + "static/media/404-error.7db1c206.webp";